import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import image2_6 from "../../../assets/images/Project/2.6.png";
import image7_2 from "../../../assets/images/Project/7.2.png";
import image7_3 from "../../../assets/images/Project/7.3.png";
import { useTranslation } from 'react-i18next';

const Products = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <section className="section bg-light" id="marketplace">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center mb-5">
                                <h2 className="mb-3 fw-semibold lh-base">
                                    {t('t-api-synch-head')}
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} className="product-item">
                            <div className="card explore-box card-animate h-100">
                                <div className="text-center mt-4 p-2">
                                    <span className="rounded-circle badge badge-soft-success p-3">
                                        <img className='avatar-sm' src={image2_6} alt='' />
                                    </span>
                                </div>
                                <div className="card-body">
                                    <h3 className="text-center">
                                        {t('t-api-synch1').split('{medPlus}')[0]}
                                        <span className='text-primary fw-semibold'>med</span><span className='text-danger fw-semibold'>Plus</span>
                                        {t('t-api-synch1').split('{medPlus}')[1]}
                                    </h3>
                                    <p className="text-muted my-2 text-center fs-17 pt-3">
                                        {t('t-api-synch1-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className="product-item">
                            <div className="card explore-box card-animate h-100">
                                <div className="text-center mt-4 p-2">
                                    <span className="rounded-circle badge badge-soft-success p-3">
                                        <img className='avatar-sm' src={image7_2} alt='' />
                                    </span>
                                </div>
                                <div className="card-body">
                                    <h3 className="text-center">
                                        {t('t-api-synch2')}
                                    </h3>
                                    <p className="text-muted my-2 text-center fs-17 pt-3">
                                        {t('t-api-synch2-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className="product-item">
                            <div className="card explore-box card-animate h-100">
                                <div className="text-center mt-4 p-2">
                                    <span className="rounded-circle badge badge-soft-success p-3">
                                        <img className='avatar-sm' src={image7_3} alt='' />
                                    </span>
                                </div>
                                <div className="card-body">
                                    <h3 className="text-center">
                                        {t('t-api-synch3')}
                                    </h3>
                                    <p className="text-muted my-2 text-center fs-17 pt-3">
                                        {t('t-api-synch3-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Products;